var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactUs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_768_1202)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.04245 0.00961595C15.0093 -0.253872 19.7518 4.93582 18.9009 10.8676C18.3069 15.0061 15.0056 18.3076 10.8672 18.9016C4.58106 19.8038 -0.802957 14.4195 0.0991893 8.13212C0.738792 3.67052 4.52613 0.208861 9.04245 0.00961595ZM10.8253 12.5137C10.83 12.1049 10.8207 11.658 10.9249 11.2605C11.1195 10.5203 12.2554 9.75495 12.8223 9.23635C14.0941 8.07347 15.0484 6.87986 14.3836 5.04196C13.4806 2.54394 10.1718 1.85589 7.87031 2.57746C6.24384 3.08768 4.94695 4.54385 4.8706 6.28585L7.2484 6.57633C7.41039 5.86315 7.71111 5.17044 8.32185 4.73564C9.4614 3.92376 11.6604 4.20773 12.0114 5.7449C12.1911 6.53444 11.8625 7.02138 11.316 7.52973C10.3468 8.43099 9.03779 9.16652 8.63839 10.5165C8.48757 11.0277 8.40285 11.9252 8.46522 12.4513C8.46802 12.4773 8.46709 12.4978 8.49315 12.5137H10.8263H10.8253ZM10.8616 13.603H8.46522V15.9995H10.8616V13.603Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8248 12.5134H8.49169C8.46562 12.4975 8.46655 12.477 8.46376 12.451C8.40231 11.9249 8.4861 11.0274 8.63693 10.5163C9.03633 9.16716 10.3463 8.43069 11.3145 7.52943C11.861 7.02108 12.1897 6.53414 12.01 5.74461C11.6599 4.20837 9.45994 3.9244 8.32038 4.73534C7.70964 5.17015 7.40986 5.86285 7.24693 6.57604L4.86914 6.28555C4.94548 4.54262 6.24238 3.08738 7.86885 2.57716C10.1703 1.8556 13.4791 2.54458 14.3822 5.04166C15.0469 6.87956 14.0926 8.0741 12.8209 9.23605C12.2539 9.75465 11.1171 10.52 10.9235 11.2602C10.8192 11.6577 10.8285 12.1046 10.8239 12.5134H10.8248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8613 13.6025H8.46484V15.9991H10.8613V13.6025Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_768_1202"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactUs);
export default __webpack_public_path__ + "static/media/contact_us.849c6e799bca604c381167d83bcd189f.svg";
export { ForwardRef as ReactComponent };